<template><div class="CruiseHeadLayout">
    <div class="boat">
        <div class="boat__info boat-info" :class="{hide: hideInfo}">
            <MySlider class="boat-info__slider" :slideRatio="190 / 280"
                :slides="headPhotos" srcKey="src_next" idKey="id"
            />

            <div class="boat-info__id">{{cruiseIdString}}</div>
            <div class="boat-info__title">{{beautifulName}}</div>

            <CruiseDates :dates="dates" />

            <ShipHead :ship="shipHead" />

            <template v-if="props.slotInfoLinkRooms">
                <div class="boat-info__price-min">
                    <template v-if="min_price.is">от <PriceCurrencyV  :price="min_price" :sum="true" /></template>
                </div>

                <span class="btn btn--bluefigma" @click.stop.prevent="click_scrollTo('Cabins')" >
                    Выбрать каюту
                </span>                
            </template>
        </div>
        <div class="boat__content" :class="{short: props.short, wide: hideInfo}">
            <div class="boat__slider slider">
                <MySlider class="cruise-info__slider" :slideRatio="1 / 2"
                    :slides="headPhotos" srcKey="src_next" idKey="id"
                />
            </div>

            <slot name="boat" :hideInfoGrid="hideInfoGrid" />
        </div>
    </div>
    <slot name="after" />
</div></template>

<style lang="scss" src="./Layout.scss"></style>

<script setup>
import '@/comp/CruiseInList/CruiseInList.scss' // чтобы стили не попадали в сборку дважды 

import {onMounted, ref, unref, watch} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'

import useCruise from "@/comp/useCruise.js"

import {click_scrollTo} from '@/comp/CruiseHead/Overview/NAV.js'
import PriceCurrencyV from "@/comp/CruiseHead/PriceCurrencyV.vue"
import MySlider from '@/comp/MySlider/MySlider.vue'
import ShipHead from '@/comp/CruiseHead/ShipHead.vue'
import CruiseDates from '@/comp/CruiseHead/CruiseDates.vue'

const route = useRoute()

const hideInfo = ref(false)

const hideInfoGrid = name => {
    const hide = unref(hideInfo)
    if (!hide && 'Promotions' === name) { 
        hideInfo.value = true
    } else if (hide && 'Overview' === name) {
        hideInfo.value = false
    }
}

const { 
    beautifulName, dateStartOb, dateEndOb, is_cruise_time_published,
    shipName, shipCompany, shipStar,
    headPhotos, min_price, cruise_link_anchor, days, ship_link, 
    cruiseIdString,
    shipHead, dates,
} = useCruise(props.CruiseBook) // {cruiseHead, cruiseFull}

//console.log('headPhotos', headPhotos);

const props = defineProps({
    CruiseBook: Object, // то что вернул запрос 
    short: { // убираем минимум по высоте
        type: Boolean,
        default: true,
    },
    slotInfoLinkRooms: {// показывать ссылку на бронирование
        type: Boolean,
        default: false,
    }
})

watch( 
    [   
        () => route.query.anchor,
    ],
    (   [ anchor ], 
        [old_anchor]
    ) => {
        if (anchor && anchor !== old_anchor) {
            click_scrollTo( anchor )
        }
    },
    { immediate: true }
)

</script>
